import { type VariantProps, cva } from "class-variance-authority";
import { LoaderCircle } from "lucide-react";
import type * as React from "react";

import { cn } from "@/shared/lib/utils";

const spinnerVariants = cva("animate-spin", {
	variants: {
		variant: {
			default: "text-primary",
			secondary: "text-secondary-foreground",
			destructive: "text-destructive",
			muted: "text-muted-foreground"
		},
		size: {
			default: "size-4",
			sm: "size-3",
			lg: "size-6",
			xl: "size-8"
		}
	},
	defaultVariants: {
		variant: "default",
		size: "default"
	}
});

function Spinner({
	className,
	variant,
	size,
	...props
}: React.ComponentProps<"svg"> & VariantProps<typeof spinnerVariants>) {
	return (
		<LoaderCircle className={cn(spinnerVariants({ variant, size, className }))} {...props} />
	);
}

export { Spinner, spinnerVariants };
